export const blockIconsHomeSolarPower = (
	<span className='material-symbols-outlined'>solar_power</span>
);
